import { APIResponse } from '@cbgms/api'
import { CountryCode } from '@carsys/enums/country-code'

export type GETAddressFromPostalCodeSupportResponse = APIResponse<{
  Address: string
  HouseNumber: string
  PostalCode: string
  Country: CountryCode
  City: string
  State: string
  Latitude: number
  Longitude: number
}>

export const getAddressFromPostalCodeSupportRequest = (CountryCode: string, HouseNumber: string, PostalCode: string) => ({
  api: 'support',
  request: {
    params: {
      CountryCode,
      HouseNumber,
      PostalCode
    },
    method: 'GET',
    url: '/miscellaneous/address/from-postalcode'
  }
})
